import React, { useState } from 'react';

const MyProfileSection = ({ information }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const handleEdit = () => {
    setIsEditing(!isEditing);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <p className="text-gray-600">Edita tu información personal y profesional 🎨</p>
        <button
          onClick={isEditing ? handleSave : handleEdit}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            isEditing
              ? 'bg-teal-500 text-white hover:bg-teal-600'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          {isEditing ? 'Guardar' : 'Editar'}
        </button>
      </div>

      <div className="grid gap-4">
        {information
          .filter((item) => item.id !== 1)
          .map((item) => (
            <div key={item.id} className="bg-white p-4 rounded-lg border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-3">{item.title}</h3>
              <div className="grid gap-3">
                {item.content.map((detail, index) => (
                  <div key={index} className="flex flex-col">
                    <label className="text-sm font-medium text-gray-600 mb-1">
                      {detail.label}
                    </label>
                    {isEditing ? (
                      <input
                        type="text"
                        defaultValue={detail.value}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    ) : (
                      <span className="px-3 py-2 bg-gray-50 rounded-md text-gray-700">
                        {detail.value}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MyProfileSection;
